window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const cartSummeryEle = document.querySelector('#cb-shipping-bar'); 
    if (cartSummeryEle) {
      const checkEmpty = () => {
        if (cartSummeryEle.innerHTML === '') {
          document.body.classList.add('active');
        }
      };
      checkEmpty();
      const cartUpdateMutation = new MutationObserver(checkEmpty); 
      cartUpdateMutation.observe(cartSummeryEle, { childList: true, attributes: true });
    }
  }, 3000);
});

